
import React, { useState } from 'react';
import { Button, Input, message, Steps, theme } from 'antd';

import '../../build.css'
import Buildtable from '../Buildtable';



 const Sop4=() =>{
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const [inputValue, setInputValue] = useState(''); // State for the input value

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [  
    
    {
      title: 'Introduction',
      content: <>
      <div   style={{marginTop:'2rem',}}>
      <Buildtable />
      <h6 id="profile">STATEMENT OF PURPOSE</h6>
      <p style={{ marginTop: "1rem" }}>
      In the scenario where you are transitioning directly from a {1} Computer Science and Engineering (CSE) undergraduate program to a {3} CSE master's program without any job experience and have a gap in your academic career, addressing the gap becomes an important aspect of your Statement of Purpose (SOP). In addition to emphasizing academic achievements and research interests, you'll want to provide context for the gap and demonstrate how it has contributed to your readiness for the master's program.
                </p>


           
                 <p> <strong>Academic Achievements, Research Interests, and Addressing the Gap - Key Emphasis Section</strong> </p>
                 <p></p>
                <br></br>
                <h6>Introduction: </h6>
                <p>In the introduction, you want to grab the reader's attention by clearly stating the academic field you are passionate about. Rather than beginning with personal details, dive into the subject matter. Explain what aspects of this field interest you and why. This could include specific experiences, classes, or personal moments that sparked your interest. Convey your enthusiasm for the subject and provide a brief glimpse into what you hope to achieve within this domain.</p>
                <p>
                  <strong >Mistakes that need to be taken care of:</strong> 
                  <br></br>
                  <strong>Avoid Ambiguity:</strong> Clearly articulate why this field captures your interest. Vague statements may leave the reader unsure about your genuine passion.
                 <p> <strong>Steer Clear of Clichés:</strong>  Be original in expressing your interest. Avoid clichés that might make your introduction sound generic.</p>
                </p>
                <br></br>
                


                <hr></hr>
              
       
        </div></>,
    },
    {
      title: 'background',
      content: <>
  <div className='martop'  > <p>
                  <strong>Background:-</strong> 
                    <br></br><strong>What to Include:</strong>   <br></br>
                  <strong>1  Academic Achievements:</strong> 
                  Highlight specific academic accomplishments during your undergraduate studies in {1}CSE. Mention any relevant coursework, projects, or achievements that demonstrate your proficiency in the field.
                </p>
                <p>
                      <strong>Research Interests and Personal Projects:</strong><br></br>
                      Discuss your research interests within CSE and any personal projects or initiatives you undertook during the gap. Showcase your proactive approach to staying engaged with the field, even in the absence of formal academic commitments.
                </p>
                <p><p><strong>Professional Development during the Gap:</strong></p>
                <p>If applicable, mention any self-directed learning, online courses, certifications, or workshops you pursued during the gap. This demonstrates your commitment to continuous improvement and skill development.</p>
                <p><strong>Addressing the Gap:</strong></p>
                  <p>Be transparent about the gap in your academic career. Briefly explain the reason for the gap, whether it was for personal reasons, pursuing additional skills, or any other relevant context. Emphasize how this time has contributed to your overall readiness for the master's program.</p>
             
                  <strong>Mistakes that need to be taken care of:</strong>
                </p>
              <p><strong>Relevance of Gap Experience:</strong></p>
                <p>Connect the experiences gained during the gap to your academic and career goals. Discuss how the time away from formal education has provided you with valuable insights, skills, or perspectives that will enhance your performance in the master's program.</p>
                <h6>How to Pen It:</h6>
                <p></p>
                <p>Begin by showcasing your academic achievements and research interests during your undergraduate studies, establishing a strong foundation in CSE.</p>
                <p>Discuss any personal projects, self-learning initiatives, or certifications you pursued during the gap, demonstrating your ongoing commitment to the field.</p>
                <p>Address the gap in your academic career with transparency and honesty. Briefly explain the circumstances or reasons for the gap, keeping the tone positive and forward-looking.</p>
                <p>Highlight any experiences or skills gained during the gap that are directly relevant to your academic and career goals. This could include practical experiences, internships, or projects.</p>
                <p>Conclude by reiterating your passion for CSE, your readiness for the master's program, and your eagerness to contribute to and benefit from the academic community at [University].</p>

                <p>Example:</p>
                <p>My journey in Computer Science and Engineering has been marked by a dedicated pursuit of academic excellence, evident in achievements such as [specific academic accomplishments]. Following the completion of my undergraduate studies, I took a deliberate pause to explore additional dimensions of the field and engaged in personal projects, online courses, and certifications [mention any relevant activities during the gap]. This gap period has been instrumental in providing me with a deeper understanding of [specific skills or concepts], and I am confident that these experiences have enriched my perspective and readiness for the Master's program at [University]. While the gap served as a time for personal and professional growth, it was also a strategic decision to further align my skills with the evolving landscape of Computer Science. I am eager to leverage the insights gained during this time and contribute meaningfully to the academic community at [University]. My commitment to continuous learning and passion for CSE position me as a dedicated candidate ready to embark on this academic journey.</p>

     
                
                {/* <hr></hr> */}

                <hr></hr></div> </>,
    },
    {
        title: 'Course',
        content: <>  <div class="  martop" role="alert">
  
        <p>
          <strong>Why this Course:  </strong>
        </p>

        Here, elaborate on why you are specifically interested in the course you are applying for. Discuss specific aspects of the curriculum that align with your academic and career goals. Go beyond a surface-level description; delve into the unique features, specializations, or projects that attracted you to this course.
        <p>
        <p>  <strong>Mistakes that need to be taken care of:  </strong>      </p>  
          <strong>Generic Statements:</strong> Avoid broad statements about the course. Dive into the specifics of the curriculum, mentioning particular courses or projects that resonate with your aspirations.

        </p>


        <p>
        <p>  <strong>Neglecting Skills Enhancement:  </strong>      </p>  
          <strong>Generic Statements:</strong> Clearly explain how the course will enhance your skills and contribute to your professional development.

        </p>    <hr></hr>
        <p>
          <strong>
          Career Goals

            {/* {data[2].Content} */}
             
          </strong>
       
        </p>
        <p>
          <strong>
          Explanation: 
           
          </strong>{" "}
          
          In this section, clearly outline your short-term and long-term career goals. Specify what you aim to achieve immediately after completing the course and paint a vivid picture of your aspirations for the next 10-15 years. Avoid mentioning a desire to stay in a foreign country for an extended period, as it can be perceived as a lack of commitment.
        </p>
        <p>
          <strong>
            
            
          Mistakes that need to be taken care of:
          </strong>{" "}
          <br></br>
         <strong>Vagueness:</strong>  Clearly define your goals, providing details about the industry, role, or projects you aim to be involved in.
        </p>
        <p>
          <strong>  Contradictions: </strong>{" "}
          Ensure that your stated goals align with the course you are applying for. Consistency is crucial for credibility.
        </p>       
        <hr></hr>
        </div>
        </>,
      },
      {
        title: 'Goals',
        content: <>
        <div className='martop'></div>
          <p >
                    <strong>Why this University:</strong>
                  </p>
                  <li>
                  This section is your chance to show that you've done your homework on the university. Highlight specific features, resources, or faculty members that attract you. Explain how these elements align with your academic and career objectives. Convey a genuine interest in what the university offers beyond just a prestigious name.
                  </li>
                <p><strong>Mistakes that need to be taken care of:</strong></p>
                <p><strong>Generic Praise:</strong></p>
                <p>Avoid using generic statements about the university's reputation. Instead, focus on unique features that resonate with your goals.</p>
                <p><strong>Lack of Personalization: </strong>Ensure your reasons for choosing the university go beyond general information available on their website. Personalize your response to demonstrate a deep understanding.</p>
        </>,
      },
      {
        title: 'Second',
        content: <>
      
        Conclusion: Summarize the key points discussed in your Statement of Purpose. Reiterate your passion for the chosen field and emphasize how the course at the university is a crucial step toward achieving your goals. End on a strong note, leaving a lasting impression.
      <br></br>  <strong>Introducing New Information: </strong>The conclusion is not the place for new information. Stick to summarizing what you've already discussed.
        <br></br><strong>Lack of Confidence: </strong>  Convey confidence in your goals and how the chosen course at the university is integral to your success.
        </>,
      },
  ];

  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    // color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    // marginTop: 16,
  };

  return (
    <>
      <Steps current={current} items={items} />
      <div style={contentStyle}>{steps[current].content}</div>
      <div
        style={{
          marginTop: 24,
        }}
      >
         {current > 0 && (
          <Button
            style={{
              margin: '0 8px',
            }}
            onClick={() => prev()}
          >
            Previous
          </Button>
        )}{current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
       
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success(`Processing complete! Input: ${inputValue}`)}>
            Done
          </Button>
        )}
       
      </div>
    </>
  );
};

export default Sop4;
